import { searchPlotStyles } from '../../api/plot-styles.api';
import { SearchPlotStylesApiRequest } from '../../../../types/requests/plot-styles/search-plot-styles.request';
import { useAxiosInfiniteQuery } from './use-axios.hook';

const baseQueryKey = 'plot-style';
const searchQueryKey = 'search';

export const usePlotStyles = (params: SearchPlotStylesApiRequest) => {
  const { data, ...result } = useAxiosInfiniteQuery({
    queryKey: [baseQueryKey, searchQueryKey, params],
    queryFn: async ({ pageParam }) => (await searchPlotStyles({ cursor: pageParam, ...params })).data,
    initialPageParam: params.cursor,
    getNextPageParam: (lastResponse) => lastResponse.nextCursor,
  });
  return { ...result, response: data } as const;
};
